"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _mwNumberAlignment = require("../mw-number-alignment");

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var DEFAULT_UNIT_LABEL = '';
var DEFAULT_ALIGN = _mwNumberAlignment.Alignment.CENTER;
/**
 * A class to represent the visualization options for Number Delta
 * @param {object} options - options object (See below)
 * @param {string} [options.unit = ''] - The unit label to be displayed
 * @param {string} [options.align = 'center'] - set alignment direction
 *
 * @property {string} unit - The label to display as the unit
 */

var MwNumberDeltaOptions = function MwNumberDeltaOptions(options) {
  (0, _classCallCheck2.default)(this, MwNumberDeltaOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.align === undefined) {
    safeOptions.align = DEFAULT_ALIGN;
  } else if (!(0, _mwNumberAlignment.isValidAlignment)(safeOptions.align)) {
    throw new TypeError("options.align must be a recognized Alignment if a string is provided. Provided value: ".concat(safeOptions.align));
  }

  if (safeOptions.unit === undefined) {
    safeOptions.unit = DEFAULT_UNIT_LABEL;
  } else {
    _argumentContracts.default.assertString(safeOptions.unit, 'options.unit');
  }

  this.align = safeOptions.align;
  this.unit = safeOptions.unit;
  Object.freeze(this);
};

exports.default = MwNumberDeltaOptions;